<template>
  <div class="layout">
    <layout-header v-if="route.meta.layoutHeader"></layout-header>
    <keep-alive>
      <router-view v-if="route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!route.meta.keepAlive"></router-view>
    <layout-footer v-if="route.meta.name!='promotion'">
      
    </layout-footer>
    <el-backtop :bottom="100" :visibility-height="50"></el-backtop>
    
  </div>
</template>

<script>
import LayoutHeader from "./layout-header.vue";
import LayoutFooter from "./layout-footer.vue";
export default {
  name: "layout",
  components: {
    LayoutHeader,
    LayoutFooter,
  },
  data() {
    return {};
  },
  computed: {
    route() {
      console.log(this.$route.meta);
      return this.$route;
    },
  },
  watch: {
    route() {
      this.$route;
    },
  },
  methods: {},
};
</script>

<style scoped lang='less'>
.el-main {
  overflow: inherit;
}
</style>



// WEBPACK FOOTER //
// src/framework/layout.vue